import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import { useEffect } from 'react';

export function usePhotoSwipeLightbox(id?: string) {
  useEffect(() => {
    if (!id) return () => {};

    let lightbox: PhotoSwipeLightbox | null = new PhotoSwipeLightbox({
      gallery: `#${id}`,
      children: '.previewable',
      pswpModule: () => import('photoswipe'),
      wheelToZoom: true,
    });

    // 从 data 属性中读取图片数据
    lightbox.addFilter('domItemData', (itemData, element) => {
      const src = element.getAttribute('data-pswp-src');
      const width = element.getAttribute('data-pswp-width');
      const height = element.getAttribute('data-pswp-height');

      return {
        ...itemData,
        src: src || itemData.src,
        width: width ? parseInt(width, 10) : itemData.width,
        height: height ? parseInt(height, 10) : itemData.height,
      };
    });

    lightbox.init();

    return () => {
      lightbox?.destroy();
      lightbox = null;
    };
  }, []);
}
